import React from "react";
import { Menu, Skeleton } from "antd";
import "./styles.scss";

const LoadingOption = ({ style }) => (
  <Menu.Item
    title="Loading..."
    value="loading"
    style={style}
    className="unclickable-option menu-item"
  >
    <div>
      <Skeleton
        active
        round
        paragraph={{ rows: 4, width: ["100%", "80%", "50%"] }}
        className="dropdown-loader"
      />
    </div>
  </Menu.Item>
);

export default LoadingOption;
